import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  LuSettings,
  LuBriefcaseBusiness,
  LuUsersRound,
  LuCalendar,
  LuCompass,
  LuList,
  LuUserSearch,
  LuUserCog,
  LuCircleDollarSign,
  LuLogOut,
  LuLayers,
  LuWarehouse,
  LuBriefcase,
  LuFileText,
} from "react-icons/lu";

import { SidebarItem } from "./sidebar-item";
import { useAppDispatch } from "../../data/store/hooks";
import { logout } from "../../data/store/reducers/userSlice";

export const SidebarMobile = ({ setMobileMenuOpen }: any) => {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const dispatch = useAppDispatch();

  const [expandedUsers, setExpandedUsers] = useState(false);
  const [expandedPosts, setExpandedPosts] = useState(false);

  const isUsersActive = pathname.startsWith("/users");
  const isPostsActive = pathname.startsWith("/posts");

  return (
    <div className="border rounded-b-2xl bg-white">
      <div>
        <div className="ml-6 mt-4 mb-2 text-xs text-gray-400 font-bold">
          MAIN
        </div>
        <div className="px-2 flex flex-col space-y-1">
          <SidebarItem
            label="Overview"
            icon={LuCompass}
            isActive={pathname === "/"}
            onClick={() => navigate("/")}
          />

          <SidebarItem
            label="Users"
            icon={LuUsersRound}
            isActive={!expandedUsers && isUsersActive}
            onClick={() => setExpandedUsers(!expandedUsers)}
            hasSubItems
            isExpanded={expandedUsers}
          />
          {expandedUsers && (
            <>
              <SidebarItem
                label="All users"
                icon={LuUserCog}
                isActive={pathname === "/users/all"}
                onClick={() => {
                  setMobileMenuOpen(false);
                  navigate("/users/all");
                }}
                indentLevel={1}
              />
              <SidebarItem
                label="Professionals"
                icon={LuBriefcase}
                isActive={pathname === "/users/professionals"}
                onClick={() => {
                  setMobileMenuOpen(false);
                  navigate("/users/professionals");
                }}
                indentLevel={1}
              />
              <SidebarItem
                label="Employers"
                icon={LuUserSearch}
                isActive={pathname === "/users/employers"}
                onClick={() => {
                  setMobileMenuOpen(false);
                  navigate("/users/employers");
                }}
                indentLevel={1}
              />
            </>
          )}
        </div>
        <div className="ml-6 mt-4 mb-2 text-xs text-gray-400 font-bold">
          GENERAL
        </div>
        <div className="px-2 flex flex-col space-y-1">
          <SidebarItem
            label="Posts"
            icon={LuList}
            isActive={!expandedPosts && isPostsActive}
            onClick={() => setExpandedPosts(!expandedPosts)}
            hasSubItems
            isExpanded={expandedPosts}
          />
          {expandedPosts && (
            <>
              <SidebarItem
                label="Jobs"
                icon={LuBriefcase}
                isActive={pathname === "/posts/jobs"}
                onClick={() => {
                  setMobileMenuOpen(false);
                  navigate("/posts/jobs");
                }}
                indentLevel={1}
              />
              <SidebarItem
                label="Projects"
                icon={LuFileText}
                isActive={pathname === "/posts/projects"}
                onClick={() => {
                  setMobileMenuOpen(false);
                  navigate("/posts/projects");
                }}
                indentLevel={1}
              />
            </>
          )}
        </div>
        <div className="px-2 mt-1 flex flex-col space-y-1">
          <SidebarItem
            label="Applications"
            icon={LuBriefcaseBusiness}
            isActive={pathname === "/applications"}
            onClick={() => {
              setMobileMenuOpen(false);
              navigate("/applications");
            }}
          />
          <SidebarItem
            label="Interviews"
            icon={LuCalendar}
            isActive={pathname === "/interviews"}
            onClick={() => {
              setMobileMenuOpen(false);
              navigate("/interviews");
            }}
          />
          <SidebarItem
            label="Transactions"
            icon={LuCircleDollarSign}
            isActive={pathname === "/transactions"}
            onClick={() => {
              setMobileMenuOpen(false);
              navigate("/transactions");
            }}
          />
        </div>
        <div className="ml-6 mt-4 mb-2 text-xs text-gray-400 font-bold">
          CONFIGURATION
        </div>
        <div className="px-2 flex flex-col space-y-1">
          <SidebarItem
            label="Categories"
            icon={LuLayers}
            isActive={pathname === "/categories"}
            onClick={() => {
              setMobileMenuOpen(false);
              navigate("/categories");
            }}
          />
          <SidebarItem
            label="Industries"
            icon={LuWarehouse}
            isActive={pathname === "/industries"}
            onClick={() => {
              setMobileMenuOpen(false);
              navigate("/industries");
            }}
          />

          <SidebarItem
            label="Settings"
            icon={LuSettings}
            isActive={pathname === "/settings"}
            onClick={() => {
              setMobileMenuOpen(false);
              navigate("/settings");
            }}
          />
          <SidebarItem
            label="Logout"
            icon={LuLogOut}
            isActive={pathname === "/logout"}
            onClick={() => {
              dispatch(logout());
              setMobileMenuOpen(false);
              navigate("/");
            }}
          />
        </div>
      </div>
      <hr className="mt-4" />
      <div className="p-6 text-gray-400">
        <div className="flex items-center space-x-1 text-sm">
          <p className="">&copy; 2025</p>
          <p>BCT.Design</p>
        </div>
        <p className="mt-1 text-xs">Connecting the dots for great talents...</p>
      </div>
    </div>
  );
};

export default SidebarMobile;
